import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { useSession } from "0.Mine/2.Context/sessionContext";
import { Business } from "0.Mine/3.Interfaces/business";
import axiosInstance from "0.Mine/axiosInstance";

import { omit } from "../utils/omit";

export const UseHandleBusiness = () => {
  const navigate = useNavigate();
  const { session } = useSession();

  useEffect(() => {
    if (!session) {
      navigate("/signin", { replace: true });
    }
    if (!session?.user) {
      navigate("/signin", { replace: true });
    }
  });

  const getOneBusiness = async (businessId: string) => {
    const userid = session.user.id;
    const token = session.user.token;
    const payloadForQuery: Record<string, string> = {
      userid: userid,
      token: token ?? "",
      action: "getbusiness",
      businessId: businessId,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/business.php?${queryString}`);

      console.log(response.data);

      if (response.data.success) {
        return response.data.data as Business;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getAllBusinesses = async () => {
    const userid = session.user.id;
    const token = session.user.token;
    const payloadForQuery: Record<string, string> = {
      userid: userid,
      token: token ?? "",
      action: "getallbusinesses",
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/business.php?${queryString}`);

      console.log(response.data);

      if (response.data.success) {
        return response.data.data as Business[];
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const editBusiness = async (business: Business) => {
    const userid = session.user.id;
    const token = session.user.token;
    const payloadForQuery: Record<string, string> = {
      action: "editbusiness",
      userid: userid,
      token: token ?? "",
      id: business.id.toString(),
      data: JSON.stringify(business),
    };
    try {
      console.log("PAYLOAD IS", payloadForQuery);
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/business.php?${queryString}`);
      console.log(response);
      return response.data.success;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const addBusiness = async (business: Business) => {
    const userid = session.user.id;
    const token = session.user.token;
    const businessWithoutImage = omit(business, ["logoUrl", "coverUrl"]);
    const payloadForQuery: Record<string, string> = {
      userid: userid,
      token: token ?? "",
      action: "onboarding",
      data: JSON.stringify(businessWithoutImage),
    };
    const queryString = new URLSearchParams(payloadForQuery).toString();
    try {
      // Append query string to your endpoint URL
      const response = await axiosInstance.post(`POST/business.php?${queryString}`);
      return {
        id: response.data.data.id,
        userId: response.data.data.userId,
      };
    } catch (error) {
      console.log(error);
    }
  };

  const getBusiness = async (businessId: string) => {};

  return { getAllBusinesses, editBusiness, addBusiness, getOneBusiness };
};
